<template>
  <el-menu class="navbar" mode="horizontal">
    <div style="display: flex; flex-direction: row;">
      <hamburger v-if="device!=='mobile'" class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <div class="back-container" v-if="currentSTUModule !== 'overview'">
        <el-button type="primary smaller" @click="redirectSTU">
          <i class="el-icon-arrow-left"></i>
          Muka Depan
        </el-button>
      </div>
      <breadcrumb></breadcrumb>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'balance',
      'device'
    ]),
    currentSTUModule() {
      return this.$store.state.user.currentSTUModule
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    redirectSTU() {
      this.$router.push(`/mysubsidi/overview?refresh=1`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/variables.scss';
.navbar {
  background-color: var(--bg-color);
  border-color: #e5e7eb;
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus{
     outline: none;
    }

    .balance {
      display: inline-block;
      position: relative;
      top: -14px;

      .label {
        font-weight: 400;
        color: #606266;
        font-size: 13px;
      }
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .avatar-container {
      height: 50px;
      margin-right: 35px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .navbar {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/admin/layout/components/Navbar.vue